import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Programs from './components/Programs';
import Testimonials from './components/Testimonials';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Navbar />
      <Hero />
      <Services />
      <Programs />
      <Testimonials />
      <Booking />
      <Contact />
      <Footer />
    </div>
  );
}
